import { useSharedState } from '../config/FarmContext';
import loadUserSettings from '../hooks/userSettingsHook';
import { MapComponent } from '../components/map/MapComponent';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { BottomNav } from '../components/layout/BottomNav/BottomNav';

export const MapPage = () => {
  const { isReady } = useSharedState();

  if (!isReady) {
    loadUserSettings();
    return <LoadingSpinner />;
  }

  return (
    <>
      <MapComponent />
      <BottomNav />
    </>
  );

}